import { AxiosProxy } from '../../../api/axiosProxy/axiosProxy';
import { rejectFailedRequestAcceptEmptyData, rejectFailedRequestOrEmptyData } from '../../../lib/request/rejectFailedRequest/rejectFailedRequest';
import { OrganizationSubscription } from '@manifest-cyber/types/interface/db';

export interface PutFeatureFlagPayload extends PutFeatureFlagBody {
  name: string;
}

export interface PutFeatureFlagBody {
  enabledForOrganizationIds: string[];
  isEnabledForWholePlatform: boolean;
  description: string;
}

export interface PutOrganizationSubscriptionPayload extends PutOrganizationSubscriptionBody {
  orgId: string;
}

export interface PutOrganizationSubscriptionBody {
  subscriptions: OrganizationSubscription
}

export const AdministrationApi = {
  putFeatureFlag: async (body: PutFeatureFlagPayload) => {
    const { name, ...rest } = body;
    const response = await AxiosProxy.put({
      url: `/admin/feature-flags/${name}`,
      body: rest,
    });

    const validatedResponse =
      await rejectFailedRequestOrEmptyData<PutFeatureFlagPayload>(response);
    return validatedResponse.data;
  },
  postOrganizationSubscription: async (payload: PutOrganizationSubscriptionPayload) => {
    const { orgId, ...body } = payload;
    const url = `/admin/organizations/${payload.orgId}/subscriptions`
    const response = await AxiosProxy.put({ url, body });
    await rejectFailedRequestAcceptEmptyData<{}>(response);
  },
  putAppSetting: async (body: Record<string, boolean>) => {
    const { name, value } = body;
    const response = await AxiosProxy.put({
      url: `/admin/app-setting/${name}`,
      body: { value }
    });
    await rejectFailedRequestAcceptEmptyData<{}>(response);
  }
};
